import React from 'react';
import { Loader } from 'lucide-react';
import styles from './LoadingContainer.module.css';

const LoadingContainer = ({ 
    message = 'Loading...', 
    subMessage = '', 
    minHeight = '400px',
    fullPage = false 
}) => {
    return (
        <div 
            className={`${styles.loadingWrapper} ${fullPage ? styles.fullPage : ''}`}
            style={{ minHeight: fullPage ? '100vh' : minHeight }}
        >
            <Loader className={styles.loadingIcon} />
            <p className={styles.loadingText}>{message}</p>
            {subMessage && <p className={styles.loadingSubText}>{subMessage}</p>}
        </div>
    );
};

export default LoadingContainer;
